export async function customerShowUseCase(id, customerRepostitory) {
    const result = await customerRepostitory.show(id);

    const entity = new customerRepostitory.model_show(result.data.data.attributes);

    if (!entity.isValid()) {
        throw new Error("customer show inválido");
    }


    var client_name = entity.name;
    var settings = {};

    settings['chronos'] = {
        shipping_service: 'CHRONOS',
        storage_per_pallet_cost: entity.storage_per_pallet_cost,
        managing_cost: entity.managing_cost
    };

    entity.settings.forEach(x => {
        x.forEach(y => {
            if(settings[y.shipping_service.toLowerCase()] == undefined){
                settings[y.shipping_service.toLowerCase()] = {
                    shipping_service: y.shipping_service,
                    [y.text]: y.value
                }

                if (y.text == 'paid_reference') settings[y.shipping_service.toLowerCase()]['paid_reference_is_porcentual'] = y.is_porcentual;
            }
            else {
                if (y.text == 'cod_fee') {
                    settings[y.shipping_service.toLowerCase()]['cod_fee'] = y.value;
                    settings[y.shipping_service.toLowerCase()]['is_porcentual'] = y.is_porcentual;
                }
                else settings[y.shipping_service.toLowerCase()][y.text] = y.value;
            }
        })
    })

    return [client_name, settings];
}